import { useCallback, useState } from 'react';

type AsyncFn<TArgs extends any[], TResult> = (...args: TArgs) => Promise<TResult>;

interface UseApiRequestResult<TArgs extends any[], TResult> {
  loading: boolean;
  call: AsyncFn<TArgs, TResult>;
}

export function useApiRequest<TArgs extends any[], TResult = void>(
  fn: AsyncFn<TArgs, TResult>
): UseApiRequestResult<TArgs, TResult> {
  const [loading, setLoading] = useState(false);

  const call = useCallback(
    async (...args: TArgs) => {
      setLoading(true);
      try {
        return await fn(...args);
      } finally {
        setLoading(false);
      }
    },
    [fn]
  );

  return { loading, call };
}

